import React, { useState, useEffect } from 'react';
import './FeedbackPage.css';


const FeedbackPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [toast, setToast] = useState({ visible: false, type: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(document.body.classList.contains('dark-mode'));

  useEffect(() => {
    // Listen for dark mode changes from Navbar
    const handler = () => setDarkMode(document.body.classList.contains('dark-mode'));
    window.addEventListener('darkModeChanged', handler);
    return () => window.removeEventListener('darkModeChanged', handler);
  }, []);

  // REACT_APP_API_URL already ends with /api
  // Example: REACT_APP_API_URL=https://api.jobfind24.shop/api
  const API_URL = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL + '/feedback'
    : '/api/feedback';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToast({ visible: false, type: '', message: '' });
    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message })
      });
      if (res.ok) {
        setToast({ visible: true, type: 'success', message: 'Thank you for your feedback!' });
        setName('');
        setEmail('');
        setMessage('');
      } else {
        setToast({ visible: true, type: 'error', message: 'Failed to submit feedback.' });
      }
    } catch (err) {
      setToast({ visible: true, type: 'error', message: 'Server error.' });
    } finally {
      setLoading(false);
    }

    window.setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, 2800);
  };

  return (
    <div className={`feedback-page pro${darkMode ? ' dark' : ''}`}>
      {toast.visible && <div className={`feedback-side-toast ${toast.type}`}>{toast.message}</div>}
      <div className="feedback-card">
        <div className="feedback-header">
          <svg width="40" height="40" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill={darkMode ? '#22223b' : '#007bff'}/><path d="M8 10h8M8 14h5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>
          <h2>We Value Your Feedback</h2>
          <p className="feedback-subtext">Let us know your thoughts, suggestions, or issues. Your feedback helps us improve!</p>
        </div>
        <form className="feedback-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} required placeholder="Your Name" autoComplete="off" />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@email.com" autoComplete="off" />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} required placeholder="Type your feedback here..." rows={5} />
          </div>
          <button type="submit" className="feedback-btn" disabled={loading}>{loading ? 'Submitting...' : 'Submit Feedback'}</button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;
